import './Cards.scss';

class Cards {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['Cards'] = Cards;
export default Cards;
